/* eslint-disable @typescript-eslint/no-explicit-any */
import { gql, useQuery } from '@apollo/client';

export const STOREFRONT_REVIEWS = gql`
  query storefrontReviews($storefrontId: ID!) {
    storefrontReviews(storefrontId: $storefrontId) {
      storefrontId
      average
      total
      histogram
      reviews {
        id
        rating
        comment
        source
        createdAt
        updatedAt
        authorId
        authorName
        avatarUrl
        verifiedBuyer
      }
    }
  }
`;

const formatReviewDate = (value?: string | null) => {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

// Map a backend review onto the shape ReviewList/ReviewRow expect (comment ->
// text, ISO dates -> readable strings). verifiedBuyer is real now: the server
// checks the reviewer for a paid DogeList order with this storefront.
const toReview = (r: any) => ({
  id: r.id,
  authorId: r.authorId || null,
  authorName: r.authorName || 'DogeList member',
  avatarUrl: r.avatarUrl || null,
  rating: r.rating,
  text: r.comment || null,
  createdAt: formatReviewDate(r.createdAt),
  updatedAt: r.updatedAt && r.updatedAt !== r.createdAt ? formatReviewDate(r.updatedAt) : null,
  source: r.source || undefined,
  verifiedBuyer: !!r.verifiedBuyer
});

export const useStorefrontReviews = (storefrontId?: number | string | null) => {
  const { data, loading, error, refetch } = useQuery(STOREFRONT_REVIEWS, {
    variables: { storefrontId },
    skip: !storefrontId,
    fetchPolicy: 'cache-and-network'
  });
  const summary = data?.storefrontReviews;
  return {
    average: summary?.average ?? 0,
    total: summary?.total ?? 0,
    histogram: summary?.histogram ?? [0, 0, 0, 0, 0],
    reviews: (summary?.reviews ?? []).map(toReview),
    loading,
    error,
    refetch
  };
};
